
import trackedLink from '@marketplace/components/nav/tracked-link.vue'
import sideCartMixin from '@marketplace/components/storefront-page/parts/side-cart/sideCartMixin.js'
import tailwindConfig from '@marketplace/tailwind.config.js'
import Cookies from 'js-cookie'
import resolveConfig from 'tailwindcss/resolveConfig'
import { mapGetters } from 'vuex'

const fullConfig = resolveConfig(tailwindConfig)

const excludesRouteNames = ['cart', 'checkout']

export default {
    name: 'ThePromoBar',

    components: { trackedLink },

    mixins: [sideCartMixin],

    data() {
        return {
            isClosedByUser: false,
        }
    },

    computed: {
        ...mapGetters('global', ['getHeaderHeight', 'getRelevantVoucher']),

        targetedPromoBar() {
            return window.Store?.promoBar || null
        },

        hasTargetedPromoBar() {
            if (!this.targetedPromoBar) {
                return false
            }

            return !this.$datetime.isDateExpired(this.targetedPromoBar.ends_at)
        },

        canBeShown() {
            // Temporary enable the promo bar for logged out users
            if (
                this.isClosedByUser ||
                (this.$helpers.isLoggedIn &&
                    this.promoBarId === 'oc-promobar-3423722268786689')
            ) {
                return false
            }

            // Reenable the following check to revert the temporary fix
            // if (!this.$helpers.isLoggedIn || this.isClosedByUser) {
            //     return false
            // }

            const isExcludedRoute = excludesRouteNames.includes(
                this.$page.currentRouteName
            )

            // On mobile only show the promobar on  the homepage
            if (
                (this.$breakpoint.includes('mobile') &&
                    !this.$page.isHomePage) ||
                isExcludedRoute
            ) {
                return false
            }

            if (this.getRelevantVoucher) {
                return true
            }

            // Already saw this promo bar so don't show it again
            if (
                this.targetedPromoBar?.id ===
                parseInt(Cookies.get('promo-bar-id'))
            ) {
                return false
            }

            return this.hasTargetedPromoBar && !this.hasExpired
        },

        promoBarId() {
            return `oc-promobar-${this.targetedPromoBar?.id}`
        },

        hasExpired() {
            return this.$datetime.isDateExpired(this.targetedPromoBar?.ends_at)
        },

        promoBar() {
            if (this.getRelevantVoucher) {
                return this.voucherBar
            }

            const { translations, text_color, background_color } =
                this.targetedPromoBar

            const { url, text } =
                translations?.[this.$locale] || translations?.en

            return {
                backgroundColor:
                    background_color || fullConfig.theme.colors.creme,
                textColor: text_color || fullConfig.theme.colors.pine,
                url,
                text,
            }
        },

        voucherBar() {
            const amount = this.getRelevantVoucher.isPercentage
                ? this.$n(this.getRelevantVoucher.amount / 100, 'percent')
                : this.$n(this.getRelevantVoucher.amount, 'currency-no-decimal')

            const date = this.$datetime.shortDate(
                this.getRelevantVoucher.endsAt
            )

            return {
                backgroundColor: fullConfig.theme.colors.creme,
                textColor: fullConfig.theme.colors.pine,
                url: this.localePath({ name: 'marketplace' }),
                text: this.$t(
                    `voucher-bar.type.${this.getRelevantVoucher.type}`,
                    {
                        amount,
                        date,
                    }
                ),
            }
        },
    },

    methods: {
        hidePromoBar() {
            this.isClosedByUser = true

            if (this.getRelevantVoucher?.id) {
                Cookies.set(
                    `voucher--${this.getRelevantVoucher.id}`,
                    JSON.stringify({
                        used: 1,
                        type: this.getRelevantVoucher.type,
                    }),
                    {
                        expires: 60,
                    }
                )
            } else {
                Cookies.set('promo-bar-id', this.targetedPromoBar.id, {
                    expires: 14,
                })
            }

            const newHeaderHeight =
                this.getHeaderHeight - this.$refs.promobar.clientHeight

            this.$store.commit('global/updateHeaderHeight', newHeaderHeight)
        },
    },
}
